import { ClientStoreModel } from "@app/core/models/client/clientstore.model";
import { createAction, props } from "@ngrx/store";

export const getClient = createAction('[Client] Get Client');
export const getClientSuccess = createAction('[Client] Get Client Success', props<{data: ClientStoreModel}>());